<script setup lang="ts">
import { getTicker } from '@/api/ticker'
import { onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Ticker } from './index'
import { useSocket } from '@/socket'
import { Vue3Lottie } from 'vue3-lottie'
// import 'vue3-lottie/dist/style.css'
// @ts-ignore
import notice from './notice.json'

// 声明 JSON 模块
// declare module "*.json" {
//   const value: any;
//   export default value;
// }

const { locale } = useI18n()
const ticker = new Ticker()
const currentMessage = ref('')
const marqueeContainer = ref<HTMLElement | null>(null)
const scrollContent = ref<HTMLElement | null>(null)
const scrollPosition = ref(0)
const speed = 1
let animationFrameId: number | null = null

// 获取当前语言对应的内容
function getContentByLang(content: any) {
  // 只显示英文版本
  return content.en?.trim() || ''
}

// 获取并播放下一条消息
function playNextMessage() {
  // 添加最大重试次数，防止死循环
  const maxRetries = ticker.getSize() || 100
  let retryCount = 0
  while (retryCount < maxRetries) {
    const message = ticker.getNext()
    if (!message) {
      // 如果没有更多消息，播放默认消息
      currentMessage.value = ''
      startScroll()
      return
    }

    try {
      const content = JSON.parse(message.content)
      const messageContent = getContentByLang(content)

      if (messageContent) {
        // 如果有当前语言版本，播放该消息
        currentMessage.value = messageContent
        startScroll()
        return
      }
    }
    catch (e) {
      // 如果解析失败，继续获取下一条
      // 不做任何处理，继续循环
    }

    retryCount++
  }

  // 如果所有消息都不满足条件，播放默认消息
  currentMessage.value = ''
  startScroll()
}

// 开始滚动动画
function startScroll() {
  if (!scrollContent.value || !marqueeContainer.value)
    return

  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
  }

  scrollPosition.value = marqueeContainer.value.offsetWidth

  const animate = () => {
    if (!scrollContent.value || !marqueeContainer.value)
      return

    scrollPosition.value -= speed

    if (scrollPosition.value <= -scrollContent.value.offsetWidth) {
      // 当前消息播放完成，播放下一条
      playNextMessage()
      return
    }

    animationFrameId = requestAnimationFrame(animate)
  }

  animationFrameId = requestAnimationFrame(animate)
}

// 初始化消息列表
async function initMessages() {
  const res = await getTicker()
  ticker.clear()
  res.data.forEach((item: any) => ticker.add(item))
  playNextMessage()
}

// 监听新消息
const socket = window.$socket
socket.on('marquee_notice', initMessages)

onMounted(() => {
  initMessages()
})

onUnmounted(() => {
  if (animationFrameId !== null) {
    cancelAnimationFrame(animationFrameId)
  }
})
</script>

<template>
  <div ref="marqueeContainer" class="marquee-container">
    <div ref="scrollContent" class="scroll-content" :style="{ transform: `translateX(${scrollPosition}px)` }">
      <div class="flex" style="align-items: center; white-space: nowrap">
        <!-- <Vue3Lottie :auto-play="true" :animation-data="notice" :style="{ width: '33px', height: '33px' }" /> -->
        <!-- <img
          src="@/assets/imgs/mobile/guangbo.png"
          alt=""
          style="width: 17px; height: 17px; object-fit: cover"
        /> -->
        <div ref="messageEl" class="ticker-message">
          {{ currentMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.marquee-container {
  height: 26px;
  line-height: 26px;
  width: 100%;
  font-size: 12px;
  color: #fff;
  overflow: hidden;
  position: relative;

  * {
    -webkit-transition-property: none;
    -o-transition-property: none;
    transition-property: none;
  }
}

.scroll-content {
  position: absolute;
  left: 0;
  top: 0;
  will-change: transform;
  white-space: nowrap;
}




/* 移动端字体大小 */
.ticker-message {
  color: #fff;
  margin-left: 5px;
  font-size: 12.5px;
  /* 移动端默认字体大小 */
}

/* PC端字体大小调整 */
@media (min-width: 768px) {
  .ticker-message {
    font-size: 12px;
    /* PC端字体大小 */
  }

  .scroll-content {
    position: absolute;
    left: 0;
    top: 0;
    will-change: transform;
    white-space: nowrap;
  }
}

/* 大屏幕字体大小调整 */
@media (min-width: 1024px) {
  .ticker-message {
    font-size: 12px;
    /* 大屏幕字体大小 */
  }

  .scroll-content {
    position: absolute;
    left: 0;
    top: 0;
    will-change: transform;
    white-space: nowrap;
  }
}

/* 超大屏幕字体大小调整 */
@media (min-width: 1440px) {
  .ticker-message {
    font-size: 12px;
    /* 超大屏幕字体大小 */
  }

  .scroll-content {
    position: absolute;
    left: 0;
    top: 0;
    will-change: transform;
    white-space: nowrap;
  }
}
</style>
